export default __webpack_public_path__ + "static/favicon-3ad6cdf782467130c37c6a2d4cdcc085.png";